import { createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    specialityDetails: {
      marginTop: theme.spacing(2),
    },
    potContainer: {
      marginBottom: theme.spacing(2),
    },
    stepValue: {
      marginLeft: theme.spacing(1),
    },
    reviewDetailsContainer: {
      marginTop: theme.spacing(3),
    },
  });

export default styles;
